import firstOfDay from 'date-fns/startOfDay'
import toDate, { dateParamType } from '~/utils/gcxDates/toDate'

type startOfDayType = (date: dateParamType) => Date

const startOfDay: startOfDayType = (dateProp) => {
  const date = toDate(dateProp)
  return firstOfDay(date)
}

export default startOfDay
